import { useMemo } from 'react';
import { Clock } from 'lucide-react';

/** Today's date for the global top bar leading slot (left of location divider). */
export function HubTopBarDate() {
  const label = useMemo(
    () =>
      new Date().toLocaleDateString([], {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      }),
    []
  );

  return (
    <p className="text-sm text-header-text-muted font-medium flex items-center gap-1.5 min-w-0">
      <Clock className="w-4 h-4 flex-shrink-0" />
      <span className="truncate">{label}</span>
    </p>
  );
}
